import type { ApiResponse } from "./models/ApiResponse";
import { parseJsonApiResponse } from "./parseJsonApiResponse";
import { sanitize } from "cy-logging";

export async function toJson(response: ApiResponse) {
  const logger = response.logger;
  try {
    const logData = await parseJsonApiResponse(response);
    logger.info(`api response ${logData.url}`, {
      response: sanitize(logData),
    });
    return logData.body;
  } catch (err) {
    logger.error(
      `fetch call failed ${response.toLogMessage()}`,
      undefined,
      err,
    );

    throw err;
  }
}
